import { render, staticRenderFns } from "./viewparents.vue?vue&type=template&id=2fd679d6&scoped=true&"
import script from "./viewparents.vue?vue&type=script&lang=js&"
export * from "./viewparents.vue?vue&type=script&lang=js&"
import style0 from "./viewparents.vue?vue&type=style&index=0&id=2fd679d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd679d6",
  null
  
)

export default component.exports